import { OneClickProfileActions } from './../actions/one-click-profile.actions';
import {
  OneClickJobsiteSalesAreaActions,
  OneClickJobsiteSalesAreaActionTypes,
} from '@ordersnproducts/modules/one-click-order/actions/one-click-jobsite-sales-area.actions';
import { IJobsiteSalesArea } from '@cemex-core/cmx-api';

export interface OneClickJobsiteSalesAreaState {
  loading: boolean;
  jobsiteSalesAreaLoaded: IJobsiteSalesArea[];
  purchaseOrderRequired: boolean;
  validating: boolean;
}

export const initialState: OneClickJobsiteSalesAreaState = {
  loading: false,
  jobsiteSalesAreaLoaded: [],
  purchaseOrderRequired: null,
  validating: false,
};

export function reducer(
  state = initialState,
  action: OneClickJobsiteSalesAreaActions | OneClickProfileActions,
): OneClickJobsiteSalesAreaState {
  switch (action.type) {
    case OneClickJobsiteSalesAreaActionTypes.LOAD_JOBSITE_SALES_AREA: {
      return {
        ...state,
        loading: true,
      } as OneClickJobsiteSalesAreaState;
    }
    case OneClickJobsiteSalesAreaActionTypes.LOAD_JOBSITE_SALES_AREA_COMPLETE: {
      return {
        ...state,
        loading: false,
        jobsiteSalesAreaLoaded: action.payload,
      } as OneClickJobsiteSalesAreaState;
    }
    case OneClickJobsiteSalesAreaActionTypes.MANDATORY: {
      return {
        ...state,
        purchaseOrderRequired: action.payload,
      } as OneClickJobsiteSalesAreaState;
    }
    case OneClickJobsiteSalesAreaActionTypes.VALIDATE_START: {
      return {
        ...state,
        validating: true,
      } as OneClickJobsiteSalesAreaState;
    }
    case OneClickJobsiteSalesAreaActionTypes.VALIDATE_END: {
      return {
        ...state,
        validating: false,
      } as OneClickJobsiteSalesAreaState;
    }
    case OneClickJobsiteSalesAreaActionTypes.LOAD_ERROR:
    case OneClickJobsiteSalesAreaActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
